<!--
 * @Author: your name
 * @Date: 2021-06-22 11:36:44
 * @LastEditTime: 2022-01-24 10:23:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolText.vue
-->
<!--文本-->

<template>
  <div class="tool-text" :style="eleStyle">
    <div class="text-val">
      <pre>{{media.ext_val_content}}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolText",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  created() {

  },
  computed: {
    eleStyle() {
      return {
        'font-size': this.media.ext_val_textSize * 1 * this.ratio + 'px',
        'font-family': this.media.ext_val_family,
        'background': this.media.ext_val_backgroundColor,
        'color': this.media.ext_val_textColor,
        'font-weight': this.media.ext_val_isBold ? 'bold' : 'normal',
        'font-style': this.media.ext_val_isItalic ? 'oblique' : 'normal',
        'text-decoration': this.media.ext_val_underLine ? 'underline' : 'none',
        'text-align': { 1: 'left', 4: 'center', 2: 'right' }[this.media.ext_val_halign],
        'justify-content': { 32: 'flex-start', 128: 'center', 64: 'flex-end' }[this.media.ext_val_valign]
      }
    },
    ratio() {
      return this.$store.state.program.ratio;
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-text {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  user-select: none;
  overflow: hidden;
  // font-style: oblique; // 斜体
  // font-weight: bold; // 加粗
  // text-decoration: underline; // 下划线
  // text-align: center;
  // text-align: left;
  // text-align: right;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // justify-content: flex-start;
  // justify-content: flex-end;
  .text-val {
    width: 100%;
    word-wrap: break-word;
    word-break: normal;
    pre {
      white-space: pre-wrap; /*css-3*/
      white-space: -moz-pre-wrap; /*Mozilla,since1999*/
      white-space: -pre-wrap; /*Opera4-6*/
      white-space: -o-pre-wrap; /*Opera7*/
      word-wrap: break-word; /*InternetExplorer5.5+*/
    }
  }
}
</style>